import { FiltersType, ListingRequest } from '@/api/types';
import { client } from '@/client';
import { Country } from '@/client/accounts';
import { PartialRequestMultiselect } from '@/components/form/generic/PartialRequestMultiselect';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type CountriesMultiselectInputProps = {
  onChange: (value: Country[]) => void;
  onBlur?: () => void;
  additionalFilters?: FiltersType;
  selectedOptions?: Country[];
  isDisabled?: boolean;
  accountId?: string;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange' | 'defaultChecked'>;

export const CountriesMultiselectInput: React.FC<
  CountriesMultiselectInputProps
> = ({
  onChange,
  onBlur,
  className,
  additionalFilters,
  selectedOptions,
  isDisabled,
  accountId,
}) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const fetchCountries = isDisabled
    ? undefined
    : async (params: ListingRequest) =>
        await client.accountEntities.getCountries(
          params,
          accountId || currentAccount?.id || '',
        );

  return (
    <PartialRequestMultiselect
      dataKey="name"
      fetchService={fetchCountries}
      filter
      display="chip"
      optionLabel="name"
      optionValue="value"
      placeholder={t('generic.select')}
      maxSelectedLabels={10}
      additionalFilters={additionalFilters}
      selectedOptions={selectedOptions}
      className={className}
      handleOnChange={onChange}
      onBlur={onBlur}
      disabled={isDisabled}
      isNotListingResponse
    />
  );
};
